export const HEADER_HEIGHT = {
  base: '8.8rem',
}
